type CacheEnvelope<T> = {
  ts: number
  value: T
}

const PREFIX = 'dizee:sessionCache:'

export function makeCacheKey(parts: Array<string | number | null | undefined>) {
  return (
    PREFIX +
    parts
      .filter((p) => p !== null && p !== undefined && String(p).length > 0)
      .map((p) => String(p))
      .join('|')
  )
}

export function readSessionCache<T>(key: string, ttlMs?: number): T | null {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    const parsed = JSON.parse(raw) as CacheEnvelope<T>
    if (!parsed || typeof parsed !== 'object') return null
    if (typeof parsed.ts !== 'number') return null
    if (ttlMs && Date.now() - parsed.ts > ttlMs) return null
    return parsed.value ?? null
  } catch {
    return null
  }
}

export function writeSessionCache<T>(key: string, value: T) {
  try {
    const env: CacheEnvelope<T> = { ts: Date.now(), value }
    sessionStorage.setItem(key, JSON.stringify(env))
  } catch {
    // ignore quota / serialization issues
  }
}

